import * as yup from 'yup';
import api from '@/services/api';

export const promotorSchema = yup.object({
  name: yup.string().required('Nombre es requerido')          
  .test(
   'checkDuplicateName',
   'El Nombre ya existe',
   async function (value) {
     const { id, companyTypeId  } = this.options.context || {};
     
     if (!value) return true; // Skip if empty — let `.required` handle it
     if(!companyTypeId) return true;
     try {
       const response = await api.get(`/company/validate-name?id=${id}&name=${value}&companyTypeId=${companyTypeId }`);

       return !response.data; 
     } catch (error) {
       return this.createError({
         message: 'Error al validar el nombre de la empresa',
       });
     }
   }
 ),
 ruc: yup.string().required('RUC es requerido')  
 .min(11, 'Mínimo 11 caracteres')        
 .max(11, 'Máximo 11 caracteres')        
 .test(
  'checkDuplicateRUC',
  'El RUC ya existe',
  async function (value) {
    const { id, companyTypeId  } = this.options.context || {};
    
    if (!value) return true; // Skip if empty — let `.required` handle it
    if(!companyTypeId) return true;
    try {
      const response = await api.get(`/company/validate-ruc?id=${id}&ruc=${value}&companyTypeId=${companyTypeId }`);

      return !response.data; 
    } catch (error) {
      return this.createError({
        message: 'Error al validar el RUC de la empresa',
      });
    }
  }
),
  description: yup.string().required('Descripción es requerido'),
  companyTypeId: yup.number().nullable().required('Tipo es requerido'),
  
});